"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApprovalActions = exports.approvedItemAmount = void 0;
const constants_1 = require("../constants");
const typechain_types_1 = require("../typechain-types");
const item_1 = require("./item");
const usecase_1 = require("./usecase");
const approvedItemAmount = async (owner, item, operator, provider) => {
    if ((0, item_1.isErc721Item)(item.itemType) || (0, item_1.isErc1155Item)(item.itemType)) {
        // isApprovedForAll check is the same for both ERC721 and ERC1155, defaulting to ERC721
        const contract = typechain_types_1.TestERC721__factory.connect(item.token, provider);
        const isApprovedForAll = await contract.isApprovedForAll(owner, operator);
        // Setting to the max int to consolidate types and simplify
        return isApprovedForAll ? constants_1.MAX_INT : 0n;
    }
    else if (item.itemType === constants_1.ItemType.ERC20) {
        const contract = typechain_types_1.TestERC20__factory.connect(item.token, provider);
        return contract.allowance(owner, operator);
    }
    // We don't need to check approvals for native tokens
    return constants_1.MAX_INT;
};
exports.approvedItemAmount = approvedItemAmount;
/**
 * Get approval actions given a list of insufficient approvals.
 */
function getApprovalActions(insufficientApprovals, exactApproval, signer) {
    return insufficientApprovals
        .filter((approval, index) => index === insufficientApprovals.length - 1 ||
        insufficientApprovals[index + 1].token !== approval.token)
        .map(({ token, operator, itemType, identifierOrCriteria, requiredApprovedAmount, }) => {
        const isErc1155 = (0, item_1.isErc1155Item)(itemType);
        if ((0, item_1.isErc721Item)(itemType) || isErc1155) {
            // setApprovalForAll check is the same for both ERC721 and ERC1155, defaulting to ERC721
            const contract = typechain_types_1.TestERC721__factory.connect(token, signer);
            const transactionMethods = exactApproval && !isErc1155
                ? (0, usecase_1.getTransactionMethods)(signer, contract, "approve", [
                    operator,
                    identifierOrCriteria,
                ])
                : (0, usecase_1.getTransactionMethods)(signer, contract, "setApprovalForAll", [
                    operator,
                    true,
                ]);
            return {
                type: "approval",
                token,
                identifierOrCriteria,
                itemType,
                operator,
                transactionMethods,
            };
        }
        else {
            const contract = typechain_types_1.TestERC20__factory.connect(token, signer);
            return {
                type: "approval",
                token,
                identifierOrCriteria,
                itemType,
                transactionMethods: (0, usecase_1.getTransactionMethods)(signer, contract, "approve", [operator, exactApproval ? requiredApprovedAmount : constants_1.MAX_INT]),
                operator,
            };
        }
    });
}
exports.getApprovalActions = getApprovalActions;
//# sourceMappingURL=approval.js.map